
import { createContext, useRef, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { CtaOverlayContainer } from "./CtaOverlay.styles";
import { ICtaOverlay, IDataOverlay } from "./CtaOverlay.types";
import { Download } from "./Download.component";
import { Rating } from "./Rating.component";
import { Share } from "./Share.component";
import { CreateContentModal } from "../../components/CreateContentModal";
import { POST_TYPE } from "../../consts";
import { useAuthStore, useCommunityClusterStore, useCurrentCommunityCluster } from "../../stores";
import { OutletContext } from "routes";

//@ts-ignore 
export const OverlayContext = createContext<IDataOverlay>();
export const IndexContext = createContext<number | undefined>(undefined);

const defaultOverlayData = {
  id: ""
};

export const CtaOverlayRestyle = ({ data,certificates, badge }: ICtaOverlay) => {
  
  const anchorElRef = useRef<HTMLDivElement | null>(null);
  const elAnchor = anchorElRef?.current as HTMLElement;
  
  const smartConfiguration = useAuthStore(state => state.smartConfiguration);

  const [activeIndex, setActiveIndex] = useState<number|undefined>(undefined);
  const [commentsModalIsOpen, setCommentModalIsOpen] = useState(false);

  const { availableClusters, currentCluster } = useCurrentCommunityCluster();
  const { sectionUrl } = useOutletContext<OutletContext>();
  const { setCurrentCluster } = useCommunityClusterStore();

  const sharingEnabled = !!availableClusters.find((cluster) => cluster.is_share_enabled);

  if(!currentCluster?.is_share_enabled && sharingEnabled) {
    setCurrentCluster(availableClusters.find((cluster) => cluster.is_share_enabled));
  }

  const overlayData: IDataOverlay | undefined = data;

  if(!smartConfiguration?.funcFavourites &&!smartConfiguration?.funcRating && !sharingEnabled) return <></>;
  if(!overlayData || !overlayData.id) return <></>;
  
  return (
    <IndexContext.Provider value={ activeIndex } >
      <OverlayContext.Provider value={ overlayData ?? defaultOverlayData } >

        <CtaOverlayContainer id="ctaOverlay-container">
          { /* RATING */ }
          {  smartConfiguration?.funcRating && (
            <Rating setActiveIndex={ setActiveIndex } />
          ) }
          { /* SHARE */ }
          {  sharingEnabled && (
            <Share setCommentModalIsOpen={ setCommentModalIsOpen }/>
          ) }

          { /* DOWNLOAD BADGES - go to profile */ }
          { (sectionUrl === "esplora") &&  (badge || (certificates?.length ?? 0) > 0) &&
            <Download 
              badge={ badge }
              certificates={ certificates } 
            />
          }
        </CtaOverlayContainer>

        { /* MODAL SHARING COMMENT */ }
        {
          commentsModalIsOpen ?
            <CreateContentModal
              selectedFilter={ null }
              selectedTopic={ null }
              anchorPosition={ {
                left:0,
                top:0
              } }
              anchorOrigin={ {
                horizontal: "center",
                vertical: "center"
              } }
              transformOrigin={ {
                horizontal: "center",
                vertical: "center"
              } }
              anchorEl={ elAnchor }
              closeDrawer={ () => setCommentModalIsOpen(false) }
              onClose={ () => {setCommentModalIsOpen(false)} }
              open={ commentsModalIsOpen }
              postData={ {
                loAuthor: "abc123",
                loId: data?.id.toString() ?? "",
                loType: data?.learningObjectTypology ?? "undefined"
              } }
              postType={ POST_TYPE.SHARED }
              //TODO sistemare con il commit del restyle modale  
              //@ts-ignore
              sxContainer={ {
                width:"fit-content",
                heigh: "fit-content",
                "& .MuiPaper-root.MuiPopover-paper": {
                  transform: "translateY(-50%) !important"

                }
              } }
            /> : null
        }
      </OverlayContext.Provider>
    </IndexContext.Provider>
  );
};
